module.exports = __webpack_public_path__ + "img/1514459844.4285c897.jpg";